export default "__VITE_ASSET__CDkni2fn__"